import type { AuthUser } from 'aws-amplify/auth';
import { useBscData } from './hooks/useBscData';
import { Dashboard } from './components/Dashboard';
import { ErrorPanel, LoadingPanel } from './components/StatePanels';

interface AppProps {
  user?: AuthUser;
  signOut?: () => void;
}

function userLabel(user?: AuthUser): string {
  if (!user) return 'Sviluppo locale';
  return user.signInDetails?.loginId || user.username || 'Utente autenticato';
}

export default function App({ user, signOut }: AppProps) {
  const { data, loading, refreshing, error, reload } = useBscData();

  if (loading && !data) {
    return <LoadingPanel />;
  }

  if (error && !data) {
    return <ErrorPanel error={error} onRetry={reload} />;
  }

  if (!data) {
    return (
      <ErrorPanel
        error={new Error('La sorgente dati non ha restituito una Balanced Scorecard valida.')}
        onRetry={reload}
      />
    );
  }

  return (
    <>
      {error ? (
        <div className="refresh-warning" role="alert">
          L'ultimo aggiornamento non è riuscito: {error.message}. Sono mostrati i dati già caricati.
        </div>
      ) : null}
      <Dashboard
        data={data}
        userLabel={userLabel(user)}
        refreshing={refreshing}
        onReload={reload}
        onSignOut={signOut}
      />
    </>
  );
}
